<svg width="31" height="30" viewBox="0 0 31 30" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M11.1 11.4029C14.2 11.4029 16.8 8.9029 16.8 5.7029C16.8 2.6029 14.3 0.00289827 11.1 0.00289827C7.90005 -0.0971017 5.30005 2.4029 5.30005 5.6029C5.30005 8.8029 7.90005 11.4029 11.1 11.4029Z"
    fill="#748097" />
  <path
    d="M20.5 25.356L14 18.9028C13.5566 18.4595 12.6699 18.4595 12.2266 18.9028C11.7832 19.3462 11.7832 20.2329 12.2266 20.6763L20.5 28.9028L30 15.9027C30.4434 15.4593 30.4434 14.6834 30 14.2401C29.4458 13.6859 28.67 13.7967 28.2266 14.3509L20.5 25.356Z"
    fill="#009DD6" />
  <path
    d="M20.5 25.356L14 18.9028C13.5566 18.4595 12.6699 18.4595 12.2266 18.9028C11.7832 19.3462 11.7832 20.2329 12.2266 20.6763L20.5 28.9028L30 15.9027C30.4434 15.4593 30.4434 14.6834 30 14.2401C29.4458 13.6859 28.67 13.7967 28.2266 14.3509L20.5 25.356Z"
    stroke="#009DD6" stroke-miterlimit="10" />
  <path
    d="M10 22.7028C8.4 21.1028 8.4 18.5028 10 16.9028C10.8 16.1028 11.8 15.7028 12.9 15.7028C14 15.7028 15 16.1028 15.8 16.9028L17.5 18.6028L20.2 15.6028C19 14.4028 17.3 13.6028 15.5 13.6028H6.7C3 13.6028 0 16.5028 0 20.3028V22.9028C0 23.5028 0.4 23.9028 1 23.9028H11.2L10 22.7028Z"
    fill="#748097" />
</svg>
  